const SECONDS_PER_UNIT: readonly (readonly [Intl.RelativeTimeFormatUnit, number])[] = [
    ['year', 31_536_000],
    ['month', 2_592_000],
    ['week', 604_800],
    ['day', 86_400],
    ['hour', 3_600],
    ['minute', 60],
];

/** Short, locale-aware age of a thread for the dense threads rail, e.g. "5m ago" or "yesterday". */
export const formatThreadAge = (updatedAt: string, nowMs: number, locale: string): string => {
    const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto', style: 'narrow' });
    const elapsedSeconds = Math.max(0, Math.floor((nowMs - new Date(updatedAt).getTime()) / 1000));
    const match = SECONDS_PER_UNIT.find(([, seconds]) => elapsedSeconds >= seconds);

    return match === undefined
        ? formatter.format(0, 'second')
        : formatter.format(-Math.floor(elapsedSeconds / match[1]), match[0]);
};
